import { useSideNavSupport } from './useSideNavSupport';

export function SideNavHandler() {
    useSideNavSupport();
    return null;
}
